import { z } from '../utils/zod.js';
import { dataResponse, listResponse } from '../utils/response-templates.js';
import { documentConversionStatusSchema } from '../documents.js';
import { signerKindSchema, signerRoleSchema } from '../signings.js';
import { adminOrganizationCompactSchema, adminSigningStateSchema, adminUserCompactSchema } from './compact.js';
import { staffReasonSchema } from './staff.js';
export const ADMIN_SIGNER_STATES = [
    'PENDING',
    'PROCESSING_START',
    'SIGNING',
    'PROCESSING_SIGN',
    'EXPIRED',
    'SIGNED',
];
export const ADMIN_REVIEWER_STATUSES = ['PENDING', 'APPROVED', 'REJECTED'];
export const adminSigningIdParamsSchema = z.object({
    signingId: z.string().uuid(),
});
export const adminSigningDocumentParamsSchema = adminSigningIdParamsSchema.extend({
    documentId: z.string().uuid(),
});
export const adminDocumentDownloadQuerySchema = z.object({
    reason: staffReasonSchema,
});
export const adminSigningDocumentSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    pageCount: z.number().int(),
    size: z.number().int(),
    conversionStatus: documentConversionStatusSchema,
    downloadable: z.boolean().openapi({ description: 'Whether the caller may download the file' }),
});
export const adminSigningSignerSchema = z.object({
    id: z.string().uuid(),
    email: z.string(),
    name: z.string(),
    kind: signerKindSchema,
    role: signerRoleSchema,
    order: z.number().int(),
    state: z.enum(ADMIN_SIGNER_STATES).nullable().openapi({ description: 'null until the signing is started' }),
    signedAt: z.string().datetime().nullable(),
    userId: z.string().uuid().nullable(),
    needsLogin: z.boolean(),
    signatureProvider: z.string().nullable(),
    representativeOf: z.string().uuid().nullable(),
});
export const adminSigningReviewerSchema = z.object({
    id: z.string().uuid(),
    email: z.string(),
    status: z.enum(ADMIN_REVIEWER_STATUSES),
    reviewedAt: z.string().datetime().nullable(),
});
export const adminSigningDtoSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    name: z.string(),
    state: adminSigningStateSchema,
    organizationId: z.string().uuid(),
    organization: adminOrganizationCompactSchema,
    createdBy: adminUserCompactSchema,
    signatureType: z.string().nullable(),
    strictOrder: z.boolean(),
    enhancedSecurity: z.boolean(),
    startedAt: z.string().datetime().nullable(),
    completedAt: z.string().datetime().nullable(),
    canceledAt: z.string().datetime().nullable(),
    expiredAt: z.string().datetime().nullable(),
    expirationDate: z.string().datetime().nullable(),
    documents: z.array(adminSigningDocumentSchema),
    signers: z.array(adminSigningSignerSchema),
    reviewers: z.array(adminSigningReviewerSchema),
});
export const adminSigningResponseSchema = dataResponse(adminSigningDtoSchema);
export const adminAuditTrailEntrySchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string().datetime(),
    userId: z.string().uuid().nullable(),
    requestId: z.string().nullable(),
    ipAddress: z.string().nullable(),
    action: z.string(),
    payload: z.unknown().nullable(),
});
export const adminAuditTrailResponseSchema = listResponse(adminAuditTrailEntrySchema);
